<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <!-- <div class="hint">你的年龄？</div> -->
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1671005941.png">
      <div class="input-birth" @click="showPickerPop()">{{ !education ? "选择学历" : education }}</div>

      <van-popup v-model="showPicker" position="bottom">
        <van-picker
        title="选择学历"
        show-toolbar
        :columns="types"
        :default-index="3"
        @confirm="onConfirm"
        @cancel="onCancel" />
      </van-popup>


      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon, Popup, Picker } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  data(){
    return {
      education: '',
      showPicker: false,
      types: ["博士", "硕士", "本科", "大专", "高中", "其他"]
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.education){
        Toast('请选择你的学历')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myEducation = this.education
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_intro')
      }
    },
    showPickerPop(){
      this.showPicker = true
    },
    onConfirm(value, index) {
      this.education = value
      this.showPicker = false
    },
    onCancel() {
      this.showPicker = false
    },
    recoverEducation(){
      this.education = this.$store.state.cpchoose.myEducation ? this.$store.state.cpchoose.myEducation : this.education
    }
  },
  mounted(){
    this.recoverEducation()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:160px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:146px;}
.main .pic-hint{width:228px;height:42px;margin:0 auto;margin-bottom:160px;}
.main .input-birth{
  font-size:40px;color:#eb8e80;width:340px;
  background:#fff;border:1px dashed #eb8e80;height:86px;line-height:86px;margin:0px auto;
}
.main .arrows{position:fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
.main .datepicker{z-index:100;}
</style>
